import { render, staticRenderFns } from "./authorize-protocol.vue?vue&type=template&id=4d58a27f&scoped=true&"
import script from "./authorize-protocol.vue?vue&type=script&lang=js&"
export * from "./authorize-protocol.vue?vue&type=script&lang=js&"
import style0 from "./authorize-protocol.vue?vue&type=style&index=0&id=4d58a27f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d58a27f",
  null
  
)

export default component.exports